// Share, QR, print, and invite links carry their access token in the path (SPA routes and the public APIs behind
// them) or `?invite=`, and Clerk puts session tokens in `__clerk_*` params (also URL-encoded inside redirect params);
// tokens are credentials, so none reach PostHog or Sentry.
const S = "(?:\\/|%2F)"
const TOKEN_PATH = new RegExp(
	`(${S}(?:invite|q|share${S}selections|print${S}token|api${S}public${S}(?:qr|selection-sheets|print)|api${S}invitations${S}preview)${S})[^/?#&\\s"'<>%]+`,
	"gi",
)
const TOKEN_PARAM = /((?:[?&#]|%3F|%26|%23)(?:invite|__clerk_[a-z_]+)(?:=|%3D))[^&#\s"'<>%]+/gi
// Sentry's router tracing copies the bare `$token` route param onto spans as `params.token`, `url.path.parameter.token`, ….
// Dotted keys only: a plain `token` is PostHog's project key, and redacting it drops every event.
const TOKEN_KEY = /\.token$/i

/** Strip access tokens from every string value and key, walking plain objects and arrays (other objects pass through). */
export function redactTokens<T>(value: T): T {
	if (typeof value === "string") {
		return value.replace(TOKEN_PATH, "$1[redacted]").replace(TOKEN_PARAM, "$1[redacted]") as T
	}
	if (Array.isArray(value)) {
		return value.map(redactTokens) as T
	}
	// Plain objects only (rebuilding the event's Date timestamp would empty it), keys included (heatmaps key by page URL).
	if (value !== null && typeof value === "object" && Object.getPrototypeOf(value) === Object.prototype) {
		return Object.fromEntries(
			Object.entries(value).map(([k, v]) => [redactTokens(k), typeof v === "string" && TOKEN_KEY.test(k) ? "[redacted]" : redactTokens(v)]),
		) as T
	}
	return value
}
